import { FC } from 'react'
import { WhenShow, Checkbox, Icon } from 'mk-pc'

interface Props {
  row: any
  getValue: Function
  onChange?: (value: boolean, row: any) => void
}

/**
 * 箭头图标
 * @param param0
 * @returns
 */
const ArrowIcon = ({ name }: { name: string }) => {
  return <Icon name={name} size="12" color="rgba(140, 140, 140, 0.5)" />
}

/**
 * 表格列
 * @param props
 * @returns
 */
export const TableColumn: FC<Props> = (props) => {
  const { row, getValue, onChange } = props

  /**
   * 监听复选框选择
   * @returns
   */
  const hanleCheckChange = (e: any, row: any) => {
    row.getToggleSelectedHandler()(e)

    if (!onChange) return
    onChange(e.target.checked, row)
  }

  return (
    <div
      className="grantable-table__cell"
      style={{
        paddingLeft: `${row.depth * 24}px`
      }}
    >
      <span className="grantable-table__expandicon">
        <WhenShow when={row.getCanExpand()}>
          <button className="grantable-table__expandicon-button" onClick={row.getToggleExpandedHandler()} style={{ cursor: 'pointer' }}>
            <ArrowIcon name={row.getIsExpanded() ? 'icon-arrow-down-filling' : 'icon-arrow-right-filling'} />
          </button>
        </WhenShow>
      </span>
      <Checkbox indeterminate={row.getIsSomeSelected()} checked={row.getIsSelected()} onChange={(e: any) => hanleCheckChange(e, row)} />
      {getValue()}
    </div>
  )
}
